import { Chip, TextField, MenuItem } from '@mui/material';
import { Box, Stack } from '@mui/system';
import React from 'react';
import { Plan } from '../features/plans/plans';

// --- Small helper: plans multi-select ---
export const PlansMultiSelect = ({
  plansState,
  value,
  onChange,
}: {
  plansState: Plan[];
  value: string[];
  onChange: (ids: string[]) => void;
}) => {
  // Try to be defensive about shape of plansState
  /* eslint-disable-next-line */
  const options = plansState;

  return (
    <TextField
      select
      SelectProps={{
        multiple: true,
        value,
        onChange: (e) => {
          const next = Array.isArray(e.target.value) ? e.target.value.map(String) : [];
          onChange(next);
        },
        renderValue: (selected) => (selected as string[]).join(', '),
      }}
      label="Plans"
      helperText="Select plans this coupon applies to"
      fullWidth
    >
      {options.map((opt) => (
        <MenuItem key={opt.id} value={opt.id}>
          <Stack direction="row" spacing={1} alignItems="center" sx={{ width: '100%' }}>
            <Box sx={{ flexGrow: 1 }}>{opt.name}</Box>
            <Chip size="small" label={opt.id} />
          </Stack>
        </MenuItem>
      ))}
    </TextField>
  );
};
